// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 6: DIE MISSIONSREISEN VON PAULUS
// ============================================================================
// Ebenen 66-78 (13 Ebenen, 39 Fragen)

export const chapter6Translations = {
  name: "Die Missionsreisen von Paulus",
  description: "Bis an die Enden der Erde...",
  
  spiritualWisdom: {
    principle: "Das Evangelium ist für alle Völker und muss der ganzen Welt verkündet werden",
    scripture: "Geht hin und macht alle Völker zu Jüngern (Matthäus 28,19)",
    application: "Jeder Christ ist berufen, dort Zeuge Christi zu sein, wo Gott ihn hinstellt"
  },
  
  levels: {
    66: {
      name: "Erste Missionsreise",
      challenge: "Sondert mir Barnabas und Saulus aus zu dem Werk, zu dem ich sie berufen habe...",
      easy: {
        question: "Wer begleitete Paulus auf seiner ersten Reise?",
        options: ["Petrus", "Barnabas", "Silas", "Timotheus"],
        hint: "Der 'Sohn des Trostes'",
        funFact: "👥 Barnabas hatte Paulus nach seiner Bekehrung aufgenommen - vorsehungsvolle Partnerschaft!"
      },
      medium: {
        question: "Von welcher Stadt aus brachen sie zu ihrer Mission auf?",
        options: [
          "Jerusalem",
          "Antiochia in Syrien",
          "Tarsus",
          "Damaskus"
        ],
        hint: "Die erste gemischte Gemeinde aus Juden und Heiden",
        funFact: "🚢 Antiochia: Ausgangspunkt der Evangelisierung der westlichen Welt!"
      },
      hard: {
        question: "Was offenbart diese erste Reise über die Missionsstrategie?",
        options: [
          "Man muss in seiner Region bleiben",
          "Das Evangelium überschreitet alle kulturellen Grenzen",
          "Nur Juden können gerettet werden",
          "Die Mission ist fakultativ"
        ],
        hint: "Es geht um die Universalität der Botschaft",
        funFact: "🌊 Das Mittelmeer zu überqueren = der Schritt zur weltweiten Evangelisierung!"
      }
    },
    
    67: {
      name: "Auf Zypern mit Elymas",
      challenge: "O du, voll aller List und aller Bosheit, Sohn des Teufels...",
      easy: {
        question: "Welcher Zauberer stellte sich Paulus auf Zypern entgegen?",
        options: ["Simon", "Elymas", "Apollos", "Alexander"],
        hint: "Ein falscher Prophet, der den Statthalter abwenden wollte",
        funFact: "🪄 Erste direkte Konfrontation zwischen Evangelium und Magie!"
      },
      medium: {
        question: "Was tat Paulus mit Elymas zur Strafe?",
        options: [
          "Er vertrieb ihn",
          "Er machte ihn vorübergehend blind",
          "Er ignorierte ihn",
          "Er debattierte mit ihm"
        ],
        hint: "Eine vorübergehende Blindheit, um ihm die geistlichen Augen zu öffnen",
        funFact: "👁️ Göttliche Ironie: Der, der Seelen blendet, wird vorübergehend blind!"
      },
      hard: {
        question: "Wie veranschaulicht diese Episode die Macht des Evangeliums?",
        options: [
          "Gewalt ist notwendig",
          "Die göttliche Wahrheit setzt sich gegen die Lüge durch",
          "Man muss alle Zauberer bekämpfen",
          "Paulus war rachsüchtig"
        ],
        hint: "Es geht um göttliche Autorität gegenüber Betrug",
        funFact: "⚡ Der Statthalter glaubt, als er die göttliche Macht sieht - wirksame Demonstration!"
      }
    },

    68: {
      name: "In Antiochia in Pisidien",
      challenge: "Euch musste zuerst das Wort Gottes verkündigt werden...",
      easy: {
        question: "Wo predigte Paulus, wenn er in eine Stadt kam?",
        options: [
          "Auf dem öffentlichen Platz",
          "Zuerst in der Synagoge",
          "Bei den Reichen",
          "In heidnischen Tempeln"
        ],
        hint: "Er begann immer bei seinem Volk",
        funFact: "🕍 Missionsstrategie: zuerst zu den Juden, dann zu den Heiden!"
      },
      medium: {
        question: "Wie reagierten die Juden auf die Botschaft des Paulus?",
        options: [
          "Alle nahmen sie an",
          "Sie waren geteilt: einige glaubten, andere widersetzten sich",
          "Sie blieben gleichgültig",
          "Sie vertrieben ihn sofort"
        ],
        hint: "Klassische Spaltung vor dem Evangelium",
        funFact: "⚖️ Das Evangelium spaltet immer: Annahme oder Ablehnung, keine Gleichgültigkeit!"
      },
      hard: {
        question: "Warum wendet sich Paulus den Heiden zu?",
        options: [
          "Er bevorzugte die Heiden",
          "Die Ablehnung der Juden öffnet die Tür für die Völker",
          "Es war einfacher",
          "Er gab seine Mission auf"
        ],
        hint: "Es geht um prophetische Erfüllung",
        funFact: "🚪 'Licht der Völker' - Jesajas Prophezeiung von Paulus erfüllt!"
      }
    },

    69: {
      name: "Heilung in Lystra",
      challenge: "Die Götter in Menschengestalt sind zu uns herabgekommen!",
      easy: {
        question: "Was heilte Paulus in Lystra?",
        options: [
          "Einen Blinden",
          "Einen von Geburt an Gelähmten",
          "Einen Taubstummen",
          "Einen Aussätzigen"
        ],
        hint: "Jemand, der nie gelaufen war",
        funFact: "🦵 Spektakuläres Wunder: 'Steh aufrecht auf deine Füße!' - heilender Glaube!"
      },
      medium: {
        question: "Für wen hielt die Menge Paulus und Barnabas?",
        options: [
          "Könige",
          "Götter (Jupiter und Merkur)",
          "Zauberer",
          "Propheten"
        ],
        hint: "Gottheiten des griechischen Pantheons",
        funFact: "⚡ Barnabas = Jupiter (imposant), Paulus = Merkur (Redner) - kulturelles Missverständnis!"
      },
      hard: {
        question: "Wie reagiert Paulus auf diese götzendienerische Anbetung?",
        options: [
          "Er akzeptiert die Ehren",
          "Er zerreißt seine Kleider und predigt den wahren Gott",
          "Er schweigt aus Höflichkeit",
          "Er nutzt die Situation"
        ],
        hint: "Totale Ablehnung des Götzendienstes",
        funFact: "👔 Kleider zerreißen = jüdischer Horror vor Götzendienst - totale Integrität!"
      }
    },

    70: {
      name: "Steinigung und Auferstehung",
      challenge: "Als ihn die Jünger umringten, stand er auf und ging in die Stadt...",
      easy: {
        question: "Was taten die Bewohner von Lystra mit Paulus?",
        options: [
          "Sie sperrten ihn ein",
          "Sie steinigten ihn",
          "Sie verbannten ihn",
          "Sie kreuzigten ihn"
        ],
        hint: "Die traditionelle jüdische Strafe",
        funFact: "🪨 Von 'Gott' zu 'tot' an einem Tag - Unbeständigkeit der menschlichen Menge!"
      },
      medium: {
        question: "Was tat Paulus, nachdem er gesteinigt worden war?",
        options: [
          "Er floh aus der Stadt",
          "Er versteckte sich",
          "Er stand auf und ging zurück in die Stadt",
          "Er ging ins Krankenhaus"
        ],
        hint: "Übernatürlicher Mut nach dem vermeintlichen Tod",
        funFact: "💪 Wunderbare Auferstehung oder göttliche Heilung - unglaublicher Mut!"
      },
      hard: {
        question: "Was offenbart diese Verfolgung über die Kosten des Zeugnisses?",
        options: [
          "Man muss Konflikte vermeiden",
          "Für Christus zu zeugen kann das Leben kosten",
          "Paulus war unvorsichtig",
          "Die Verfolgung ist nutzlos"
        ],
        hint: "Es geht um den Preis des authentischen Zeugnisses",
        funFact: "✝️ 'Durch viele Bedrängnisse müssen wir eingehen' - Paulus' Realismus!"
      }
    },

    71: {
      name: "Das Apostelkonzil in Jerusalem",
      challenge: "Wenn ihr euch nicht beschneiden lasst, könnt ihr nicht gerettet werden...",
      easy: {
        question: "Welche wichtige Debatte fand beim Konzil in Jerusalem statt?",
        options: [
          "Die Taufe",
          "Die Beschneidung der bekehrten Heiden",
          "Der Sabbattag",
          "Die Opfergaben"
        ],
        hint: "Musste man Jude werden, um Christ zu sein?",
        funFact: "✂️ Erste große Krise: Christentum oder Judenchristentum?"
      },
      medium: {
        question: "Was war die endgültige Entscheidung des Konzils?",
        options: [
          "Beschneidung obligatorisch",
          "Freiheit für die Heiden mit einigen Empfehlungen",
          "Völlige Trennung von den Juden",
          "Verschiebung der Entscheidung"
        ],
        hint: "Öffnung für die Heiden ohne größere Einschränkung",
        funFact: "🆓 Historische Revolution: Das Evangelium frei vom mosaischen Gesetz!"
      },
      hard: {
        question: "Welche Bedeutung hat dieses Konzil für die universale Kirche?",
        options: [
          "Nebensächliches Ereignis",
          "Es begründet die Universalität des Heils allein durch den Glauben",
          "Es spaltet die Kirche",
          "Es verstärkt den Legalismus"
        ],
        hint: "Es geht um die Grundlage der universalen Kirche",
        funFact: "🌍 Ohne diese Entscheidung wäre das Christentum eine jüdische Sekte geblieben!"
      }
    },

    72: {
      name: "Zweite Reise: Timotheus",
      challenge: "Paulus wollte ihn mit sich nehmen und beschnitt ihn wegen der Juden...",
      easy: {
        question: "Wer schloss sich Paulus als junger Mitarbeiter an?",
        options: ["Markus", "Lukas", "Timotheus", "Titus"],
        hint: "Der 'geliebte Sohn' des Paulus",
        funFact: "👦 Timotheus: junges Wunderkind wurde Paulus' rechte Hand - erfolgreiche Mentorschaft!"
      },
      medium: {
        question: "Warum beschnitt Paulus Timotheus trotz der erworbenen Freiheit?",
        options: [
          "Aus gesetzlicher Verpflichtung",
          "Aus missionarischer Strategie unter den Juden",
          "Aus Tradition",
          "Aus Versehen"
        ],
        hint: "Praktische Weisheit, um Hindernisse zu vermeiden",
        funFact: "🎯 Freiheit mit Weisheit: 'Allen alles werden, um einige zu gewinnen'!"
      },
      hard: {
        question: "Wie veranschaulicht diese Haltung missionarische Flexibilität?",
        options: [
          "Paulus war unbeständig",
          "Er passte seine Methode an, ohne das Evangelium zu kompromittieren",
          "Er gab dem Druck nach",
          "Er war heuchlerisch"
        ],
        hint: "Es geht um kontextuelle Weisheit",
        funFact: "⚖️ Feste Prinzipien, flexible Methoden - Kunst des wirksamen Zeugnisses!"
      }
    },

    73: {
      name: "Die Vision vom Mann aus Mazedonien",
      challenge: "Komm herüber nach Mazedonien und hilf uns!",
      easy: {
        question: "Was sah Paulus in seiner nächtlichen Vision?",
        options: [
          "Einen Engel",
          "Einen Mann aus Mazedonien, der ihn rief",
          "Jesus, der zu ihm sprach",
          "Ein großes Licht"
        ],
        hint: "Ein Hilferuf aus Europa",
        funFact: "🌉 Entscheidende Vision: Das Evangelium kommt nach Europa - historischer Wendepunkt!"
      },
      medium: {
        question: "Welche war die erste evangelisierte europäische Stadt?",
        options: [
          "Athen",
          "Korinth",
          "Philippi",
          "Thessalonich"
        ],
        hint: "Römische Kolonie in Mazedonien",
        funFact: "🏛️ Philippi: erste europäische Gemeinde - Kontinent für immer verwandelt!"
      },
      hard: {
        question: "Was symbolisiert diese Vision für die Geschichte des Christentums?",
        options: [
          "Ein gewöhnlicher Traum",
          "Die vorsehungsvolle Expansion nach Westen",
          "Eine Halluzination",
          "Ein Planwechsel"
        ],
        hint: "Es geht um die Vorsehung, die die Geschichte lenkt",
        funFact: "🗺️ Ohne diese Vision wäre Europa vielleicht heidnisch geblieben - göttlicher Plan!"
      }
    },

    74: {
      name: "Lydia, Erste Europäische Bekehrte",
      challenge: "Der Herr öffnete Lydia das Herz, damit sie aufmerksam war...",
      easy: {
        question: "Was war Lydias Beruf?",
        options: [
          "Bäckerin",
          "Purpurhändlerin",
          "Weberin",
          "Töpferin"
        ],
        hint: "Luxushandel der damaligen Zeit",
        funFact: "🟣 Purpur = sehr teure königliche Farbe - Lydia war wohlhabend!"
      },
      medium: {
        question: "Wo traf Paulus Lydia?",
        options: [
          "Auf dem Markt",
          "Am Fluss während eines Gebets",
          "In ihrem Haus",
          "In der Synagoge"
        ],
        hint: "Ein Gebetsort im Freien",
        funFact: "🏞️ Keine Synagoge in Philippi - Gebet am Wasser nach der Tradition!"
      },
      hard: {
        question: "Was offenbart Lydias Bekehrung über das göttliche Werk?",
        options: [
          "Sie war prädisponiert",
          "Gott öffnet Herzen, die bereit sind, sein Wort zu empfangen",
          "Es war ein Zufall",
          "Paulus war überzeugend"
        ],
        hint: "Es geht um göttliches Wirken bei der Bekehrung",
        funFact: "💝 'Der Herr öffnete ihr Herz' - Gott bereitet vor und öffnet Seelen!"
      }
    },

    75: {
      name: "Gefängnis in Philippi",
      challenge: "Um Mitternacht beteten Paulus und Silas und lobten Gott...",
      easy: {
        question: "Warum wurden Paulus und Silas ins Gefängnis geworfen?",
        options: [
          "Diebstahl",
          "Störung der öffentlichen Ordnung durch Dämonenaustreibung",
          "Blasphemie",
          "Aufruhr"
        ],
        hint: "Heilung einer wahrsagenden Sklavin",
        funFact: "💸 Eine Seele zu befreien kostet ihre Ausbeuter teuer - wirtschaftliche Verfolgung!"
      },
      medium: {
        question: "Was taten Paulus und Silas im Gefängnis?",
        options: [
          "Sie beschwerten sich",
          "Sie beteten und sangen",
          "Sie bereiteten ihre Verteidigung vor",
          "Sie schliefen"
        ],
        hint: "Lobpreis trotz Ketten",
        funFact: "🎵 Lobgesänge um Mitternacht im Gefängnis - unerschütterlicher Glaube, der beeindruckt!"
      },
      hard: {
        question: "Wie verwandelte ihre Haltung die Situation?",
        options: [
          "Sie hatte keine Wirkung",
          "Sie bekehrte den Kerkermeister nach dem Erdbeben",
          "Sie ärgerte die Wächter",
          "Sie machte sie verrückt"
        ],
        hint: "Kraftvolles Zeugnis durch Beispiel",
        funFact: "🌍 Erdbeben + Zeugnis = Bekehrung des Kerkermeisters und seiner Familie!"
      }
    },

    76: {
      name: "In Athen: Der Areopag",
      challenge: "Was ihr verehrt, ohne es zu kennen, das verkündige ich euch...",
      easy: {
        question: "Auf welchen Altar bezog sich Paulus in Athen?",
        options: [
          "Auf den Gott Zeus",
          "Auf den unbekannten Gott",
          "Auf Apollon",
          "Auf Athene"
        ],
        hint: "Eine mysteriöse Inschrift, die als Ausgangspunkt diente",
        funFact: "🏛️ 'Dem unbekannten Gott' - genialer Anknüpfungspunkt an die griechische Philosophie!"
      },
      medium: {
        question: "Vor wem predigte Paulus in Athen?",
        options: [
          "Der gewöhnlichen Menge",
          "Den epikureischen und stoischen Philosophen auf dem Areopag",
          "Den Tempelpriestern",
          "Dem römischen Kaiser"
        ],
        hint: "Die griechische intellektuelle Elite",
        funFact: "🧠 Areopag = antikes Harvard - Paulus vor den größten Denkern!"
      },
      hard: {
        question: "Wie reagierten die Athener auf die Auferstehung?",
        options: [
          "Einstimmige Annahme",
          "Spaltung: Spott von einigen, Interesse von anderen",
          "Allgemeiner Zorn",
          "Totale Gleichgültigkeit"
        ],
        hint: "Typische Reaktion der Intellektuellen auf dieses Mysterium",
        funFact: "🤔 Auferstehung = Stolperstein für die stolze menschliche Intelligenz!"
      }
    },

    77: {
      name: "Korinth: Paulus der Zeltmacher",
      challenge: "Er blieb bei ihnen und arbeitete, denn sie waren Zeltmacher...",
      easy: {
        question: "Welchen Beruf übte Paulus aus, um seinen Lebensunterhalt zu verdienen?",
        options: [
          "Fischer",
          "Zeltmacher",
          "Schriftgelehrter",
          "Kaufmann"
        ],
        hint: "Handwerk, das er gelernt hatte",
        funFact: "⛺ Paulus: Apostel-Handwerker - Würde der Handarbeit bei Christen!"
      },
      medium: {
        question: "Bei wem wohnte Paulus in Korinth?",
        options: [
          "In einem Gasthaus",
          "Bei Aquila und Priszilla",
          "Beim Statthalter",
          "In der Synagoge"
        ],
        hint: "Ein Ehepaar von Zeltmachern wie er",
        funFact: "👫 Aquila und Priszilla: vorbildliches Missionarsehepaar - christliche Gastfreundschaft!"
      },
      hard: {
        question: "Warum arbeitete Paulus mit seinen Händen?",
        options: [
          "Nur aus finanzieller Notwendigkeit",
          "Um niemandem zur Last zu fallen und sein Zeugnis zu authentifizieren",
          "Aus Familientradition",
          "Weil er diesen Beruf liebte"
        ],
        hint: "Es geht um Unabhängigkeit und Glaubwürdigkeit",
        funFact: "💼 Finanzielle Autonomie = Redefreiheit - Paulus war von niemandem abhängig!"
      }
    },

    78: {
      name: "Aufruhr in Ephesus",
      challenge: "Groß ist die Diana der Epheser!",
      easy: {
        question: "Wer provozierte den Aufruhr gegen Paulus in Ephesus?",
        options: [
          "Die römischen Behörden",
          "Demetrius der Silberschmied und die Handwerker",
          "Die Philosophen",
          "Die jüdischen Priester"
        ],
        hint: "Diejenigen, die Diana-Tempel herstellten",
        funFact: "🏛️ Erster Streik der Geschichte: Das Evangelium bedroht die götzendienerische Wirtschaft!"
      },
      medium: {
        question: "Wie lange lehrte Paulus in Ephesus?",
        options: [
          "6 Monate",
          "1 Jahr",
          "2 Jahre",
          "3 Jahre"
        ],
        hint: "Sein längster missionarischer Aufenthalt",
        funFact: "📅 3 Jahre intensiver Lehre - Ephesus wurde zu einem wichtigen Missionszentrum!"
      },
      hard: {
        question: "Was offenbart dieser Aufruhr über die soziale Wirkung des Evangeliums?",
        options: [
          "Das Evangelium ändert nichts",
          "Es verwandelt wirtschaftliche und soziale Strukturen",
          "Es betrifft nur die Religion",
          "Es vermeidet Konflikte"
        ],
        hint: "Es geht um tiefgreifende gesellschaftliche Transformation",
        funFact: "💰 Wenn das Evangelium fortschreitet, verlieren die Götzen ihren Markt - wirtschaftliche Auswirkung!"
      }
    }
  }
};

export default chapter6Translations;
